"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var condition_1 = require("../shared/condition");
var react_1 = require("@formily/react");
var shared_1 = require("@formily/shared");
var expression_1 = require("./expression");
var schema_1 = require("./schema");
var pathExpRE = /\[\s*(?:([+-])\s*(\d+)?)?\s*\]/g;
var transformTargetPath = function (target, indexes, basePath) {
    if (!shared_1.isStr(target))
        return target;
    var index = 0;
    var newTarget = target
        .replace(/^\s*(\.+)/, function (_, $1) {
        var depth = $1.length;
        var path = basePath;
        for (var i = 0; i < depth; i++) {
            path = path.parent();
        }
        return path.toString() + '.';
    })
        .replace(pathExpRE, function (_, operator, delta) {
        if (delta) {
            if (operator === '+') {
                return String(indexes[index++] + Number(delta));
            }
            else if (operator === '-') {
                return String(indexes[index++] - Number(delta));
            }
        }
        else {
            if (operator === '+') {
                return String(indexes[index++] + 1);
            }
            else if (operator === '-') {
                return String(indexes[index++] - 1);
            }
        }
        return String(indexes[index++]);
    });
    pathExpRE.lastIndex = 0;
    return newTarget;
};
var getPathIndexes = function (path) {
    return path.transform(/\d+/, function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return args.map(function (i) { return Number(i); });
    });
};
exports.parseLinkages = function (fieldState, _a) {
    var _b = _a === void 0 ? {} : _a, getFieldState = _b.getFieldState, getFormState = _b.getFormState, outerScope = _b.scope;
    var schema = new schema_1.Schema(fieldState.props);
    var linkages = schema.getExtendsLinkages();
    if (!shared_1.isArr(linkages))
        return [];
    var fieldName = shared_1.FormPath.parse(fieldState.name);
    var fieldIndexes = getPathIndexes(fieldName);
    var formState = getFormState ? getFormState() : {};
    return linkages.map(function (_a) {
        var target = _a.target, condition = _a.condition, scope = _a.scope, params = __rest(_a, ["target", "condition", "scope"]);
        var newTarget = transformTargetPath(target, fieldIndexes, fieldName);
        var targetState = getFieldState ? getFieldState(newTarget) : {};
        var fieldValue = fieldName.getIn(formState.values);
        var _scope = __assign(__assign(__assign({}, outerScope), scope), { $value: fieldValue, $self: fieldState || {}, $form: formState || {}, $target: targetState || {} });
        var options = params;
        options.complie = function (path, scope) {
            if (path === void 0) { path = ''; }
            return expression_1.complieExpression(shared_1.FormPath.getIn(params, path), __assign(__assign({}, _scope), scope));
        };
        if (condition !== undefined) {
            options.condition = condition_1.JSONCondition.calculate(expression_1.complieExpression(condition, _scope), fieldValue);
        }
        options.target = newTarget;
        return options;
    });
};
exports.useValueLinkageEffect = function (_a) {
    var _b = _a === void 0 ? {} : _a, type = _b.type, resolve = _b.resolve, reject = _b.reject, scope = _b.scope;
    if (!type || !shared_1.isFn(resolve))
        return;
    var actions = react_1.createFormActions();
    var getFormState = actions.getFormState, getFieldState = actions.getFieldState, hasChanged = actions.hasChanged;
    var onFieldChange$ = react_1.FormEffectHooks.onFieldChange$;
    onFieldChange$('*').subscribe(function (fieldState) {
        if (!hasChanged(fieldState, 'value') &&
            !hasChanged(fieldState, 'initialized') &&
            !hasChanged(fieldState, 'visible')) {
            return;
        }
        var linkages = exports.parseLinkages(fieldState, {
            getFieldState: getFieldState,
            getFormState: getFormState,
            scope: scope
        });
        linkages.forEach(function (options) {
            var linkageType = options.type, condition = options.condition;
            if (linkageType !== type)
                return;
            if (shared_1.isFn(resolve)) {
                if (condition === true || condition === undefined)
                    resolve(options, actions);
            }
            if (shared_1.isFn(reject)) {
                if (condition === false)
                    reject(options, actions);
            }
        });
    });
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@formily/react-schema-renderer/lib/shared/linkage.js
// module id = 411
// module chunks = 0